import React from 'react';
import styled, { keyframes } from 'styled-components';

import { theme } from '../../theme';
import { IAnimatedLogo, LogoColorVariantEnum, LogoSizeEnum } from './animated-logo.types';

const Clear = styled.div`
	clear: both;
`;

const createLogoAnimationKeyframe = (opacity: number) => {
	return keyframes`
	0%, 70%, 100% {
		 transform: scale3D(1, 1, 1);
		 opacity: ${opacity};
	 } 35% {
		 transform: scale3D(0, 0, 1);
		 opacity: 0;
	 }
 `;
};

const logomarkDelay = createLogoAnimationKeyframe(1);

export interface IIconWithAnimation extends IAnimatedLogo {
	animationDelay: string;
}

const IconWithAnimationDelay = styled.svg<IIconWithAnimation>`
	margin: 0px;
	padding: 0px;
	float: left;
	opacity: 1;
	animation: ${logomarkDelay} 1.5s infinite ease-in-out;
	animation-delay: ${(props) => props.animationDelay};
	fill: ${(props) =>
		props.colorVariant ? theme.colors.text[props.colorVariant] : theme.colors.text[LogoColorVariantEnum.DARK]};
	width: ${(props) => props.size || LogoSizeEnum.SMALL};
	height: ${(props) => props.size || LogoSizeEnum.SMALL};
`;

export const AnimatedLogo: React.FunctionComponent<IAnimatedLogo> = ({ size, colorVariant }) => (
	<div>
		<IconWithAnimationDelay animationDelay="0.2s" viewBox="0 0 50 50" size={size} colorVariant={colorVariant}>
			<path d="M25.8,29.09A3,3,0,0,1,28.85,26H50V0H2.59A2.59,2.59,0,0,0,0,2.59V50H25.8Z" />
		</IconWithAnimationDelay>
		<IconWithAnimationDelay animationDelay="0.3s" viewBox="0 0 50 50" size={size} colorVariant={colorVariant}>
			<rect width="50" height="26.04" />
		</IconWithAnimationDelay>
		<IconWithAnimationDelay animationDelay="0.4s" viewBox="0 0 50 50" size={size} colorVariant={colorVariant}>
			<path d="M47.41,0H0V26H22.81a1.39,1.39,0,0,1,1,2.38L2.21,50H50V2.59A2.59,2.59,0,0,0,47.41,0Z" />
		</IconWithAnimationDelay>
		<Clear />
		<IconWithAnimationDelay animationDelay="0.1s" viewBox="0 0 50 50" size={size} colorVariant={colorVariant}>
			<rect width="25.8" height="50" />
		</IconWithAnimationDelay>
		<IconWithAnimationDelay animationDelay="0.2s" viewBox="0 0 50 50" size={size} colorVariant={colorVariant}>
			<polygon points="50 50 50 2.21 2.21 50 50 50" />
		</IconWithAnimationDelay>
		<IconWithAnimationDelay animationDelay="0.3s" viewBox="0 0 50 50" size={size} colorVariant={colorVariant}>
			<polygon points="0 2.21 0 50 50 50 50 0 2.21 0 0 2.21" />
		</IconWithAnimationDelay>
		<Clear />
		<IconWithAnimationDelay animationDelay="0s" viewBox="0 0 50 50" size={size} colorVariant={colorVariant}>
			<path d="M28.18,24a1.39,1.39,0,0,1-2.38-1V0H0V47.41A2.59,2.59,0,0,0,2.59,50H50V2.21Z" />
		</IconWithAnimationDelay>
		<IconWithAnimationDelay animationDelay="0.1s" viewBox="0 0 50 50" size={size} colorVariant={colorVariant}>
			<polygon points="2.21 0 0 2.21 0 50 50 50 50 0 2.21 0" />
		</IconWithAnimationDelay>
		<IconWithAnimationDelay animationDelay="0.2s" viewBox="0 0 50 50" size={size} colorVariant={colorVariant}>
			<path d="M0,50H47.41A2.59,2.59,0,0,0,50,47.41V0H0Z" />
		</IconWithAnimationDelay>
	</div>
);
